/** Workflows P5-8 (M26): ang triggers na "Nagbago ang attribute" at "Nag-click ang bisita sa isang element", kung sino ang nagpalit ng status, at ang pag-edit ng staff sa mga attribute. Isinasama sa `engage.workflows`. */
export const workflowsTriggers = {
  groups: { data: "Mga pagbabago sa datos", service: "Service desk", orders: "Mga order at quotation", field_service: "Field service" },
  exits: {
    ticketStepDone: "Gumana ang hakbang sa ticket",
    ticketStepFailed: "Hindi gumana ang hakbang sa ticket",
    ticketAssigned: "Naibigay sa isang tao",
    ticketQueued: "Naghihintay sa queue",
    clientTold: "Nasabihan ang kliyente",
    clientNotTold: "Hindi nasabihan ang kliyente",
    assetFound: "Nahanap ang asset",
    assetNotFound: "Walang ganoong asset ang kliyenteng ito",
    productsFound: "May nahanap na produkto",
    productsNotFound: "Walang tugmang produkto",
    ticketSubmitted: "Naipadala ang request",
    ticketDuplicateUsed: "Naidagdag sa bukas na request",
    ticketAbandoned: "Umalis ang kliyente o nagsara ang card",
    ticketNeedsPerson: "Dapat may tao nang tumulong",
    ticketNotSubmitted: "Hindi naipadala ang form",
    ticketsShown: "Naipakita ang mga request",
    ticketsNotVerified: "Hindi pa verified ang kliyente",
    productAdded: "Naidagdag sa cart",
    catalogueClosed: "Nagsara ang card",
    orderPlaced: "Na-place ang order",
    orderForApproval: "Naipadala para sa approval",
    orderCancelled: "Kinansela ng kliyente o nagsara ang review",
    orderFailed: "Hindi na-place ang order",
    ordersShown: "Naipakita ang mga order",
    ordersNotVerified: "Hindi naka-sign in ang kliyente",
  },
  kinds: { widgetOnly: "Sa website widget lang" },
  triggers: {
    ticket_created: "Nagawa ang ticket",
    ticket_updated: "Na-update ang ticket",
    ticket_state_changed: "Nagbago ang status ng ticket",
    ticket_assigned: "Na-assign ang ticket",
    ticket_returned_to_queue: "Bumalik sa queue ang ticket",
    ticket_customer_replied: "Sumagot ang kliyente",
    ticket_staff_replied: "Sumagot ang team",
    ticket_note_added: "May idinagdag na internal note",
    ticket_sla_warning: "Malapit na sa SLA target ang ticket",
    ticket_sla_breached: "Napalampas ang SLA target",
    ticket_unassigned_due: "Wala pa ring assignee ang ticket",
    ticket_waiting_reminder_due: "Oras na para sa paalala",
    ticket_pending_expired: "Tapos na ang paghihintay",
    ticket_resolved: "Na-resolve ang ticket",
    ticket_reopened: "Binuksang muli ang ticket",
    ticket_auto_close_due: "Handa nang isara",
    ticket_csat_received: "May natanggap na rating",
    ticket_intake_requested: "Gustong magbukas ng ticket ng kliyente",
    order_placed: "Na-place ang order",
    order_status_changed: "Nagbago ang status ng order",
    order_approval_requested: "Kailangan ng pag-apruba ang order",
    order_approval_decided: "Napagpasyahan ang pag-apruba ng order",
    order_sync_failed: "Hindi maipadala ang order",
    quote_status_changed: "Nagbago ang status ng quotation",
    visit_scheduled: "Naka-iskedyul ang pagbisita",
    visit_status_changed: "Nagbago ang status ng pagbisita",
    visit_reminder_due: "Oras na para sa paalala ng pagbisita",
    asset_maintenance_due: "Due na ang maintenance",
    asset_warranty_expiring: "Malapit nang matapos ang warranty",
    contract_expiring: "Malapit nang matapos ang kontrata",
    rma_status_changed: "Nagbago ang status ng return",
    attribute_changed: "Nagbago ang attribute",
    visitor_clicks_element: "Nag-click ang bisita sa isang element",
    platform_event: "Anumang event na natatanggap ng iyong endpoints",
    handoff_reminder_due: "Oras na para sa paalala ng handoff",
    handoff_escalation_due: "Oras na para i-escalate ang handoff",
    handoff_waiting_digest_due: "Handa nang iulat ang mga handoff sa labas ng oras",
    conversation_returned_to_queue: "Ibinalik sa queue ang usapan",
    lead_followed_up: "Nagtanong ulit ang lead",
    gap_assigned: "Naitalaga ang knowledge gap",
    connector_event_received: "Kaganapan mula sa konektadong system",
  },
  triggerHints: {
    ticket_created: "Magsimula kapag may nagawang ticket, sa anumang paraan.",
    ticket_updated: "Kumilos kapag nagbago ang pamagat, uri, priority, tags, sagot o due date ng ticket.",
    ticket_state_changed: "Kumilos kapag lumipat ang ticket sa ibang status.",
    ticket_assigned: "Kumilos kapag nagbago ang team o assignee ng ticket.",
    ticket_returned_to_queue: "Alertuhan ang team kapag umalis ang miyembro at bumalik sa queue ang mga ticket niya.",
    ticket_customer_replied: "Kumilos kapag sumulat ang kliyente sa ticket.",
    ticket_staff_replied: "Kumilos kapag sinagot ng team ang kliyente sa ticket.",
    ticket_note_added: "Kumilos kapag may nagdagdag ng internal note, at sa mga na-mention.",
    ticket_sla_warning: "Magbabala bago mapalampas ang first-response o resolution target.",
    ticket_sla_breached: "Kumilos kapag napalampas ang first-response o resolution target.",
    ticket_unassigned_due: "I-escalate ang ticket na walang kumuha pagkalipas ng paghihintay.",
    ticket_waiting_reminder_due: "Paalalahanan ang kliyente na hinihintay namin ang sagot niya.",
    ticket_pending_expired: "Kumilos sa ticket na hindi sinagot ng kliyente sa itinakdang oras.",
    ticket_resolved: "Magsimula kapag na-resolve ang ticket, halimbawa para humingi ng rating.",
    ticket_reopened: "Kumilos kapag binuksang muli ang na-resolve na ticket.",
    ticket_auto_close_due: "Isara ang mga na-resolve na ticket pagkalipas ng itinakdang araw.",
    ticket_csat_received: "Kumilos kapag nag-rate ang kliyente ng na-resolve na ticket.",
    ticket_intake_requested: "Gabayan ang kliyente sa pagbubukas ng ticket sa chat.",
    order_placed: "Gumawa ng aksyon kapag na-place ang isang order, o tinanggap ang request sa workspace na walang order API.",
    order_status_changed: "Gumawa ng aksyon kapag inilipat ng order system ang isang order sa bagong status.",
    order_approval_requested: "Gumawa ng aksyon kapag lampas sa limit ang isang order at naghihintay ng approver.",
    order_approval_decided: "Gumawa ng aksyon kapag natapos ang pag-apruba: inaprubahan, tinanggihan, nag-expire o binawi.",
    order_sync_failed: "Gumawa ng aksyon kapag hindi naisulat sa order system ang isang order matapos ang ilang subok.",
    quote_status_changed: "Gumawa ng aksyon kapag hiniling, napresyuhan, tinanggap, tinanggihan o nag-expire ang isang quotation.",
    visit_scheduled: "Gumawa ng aksyon kapag na-book o nalipat sa bagong oras ang isang pagbisita.",
    visit_status_changed: "Gumawa ng aksyon kapag na-dispatch, nagsimula, natapos, nakansela o hindi natuloy ang isang pagbisita.",
    visit_reminder_due: "Gumawa ng aksyon kapag oras nang paalalahanan ang kliyente o ang engineer tungkol sa pagbisita.",
    asset_maintenance_due: "Gumawa ng aksyon kapag due na ang preventive maintenance o calibration ng isang asset.",
    asset_warranty_expiring: "Gumawa ng aksyon kapag malapit nang matapos ang warranty ng isang asset.",
    contract_expiring: "Gumawa ng aksyon kapag malapit nang matapos ang isang service contract.",
    rma_status_changed: "Gumawa ng aksyon kapag lumipat sa bagong status ang isang return.",
    attribute_changed: "Tumugon kapag nagbago ang attribute ng usapan, bisita o lead.",
    visitor_clicks_element: "Magpadala ng mensahe kapag nag-click ang bisita sa button o link sa inyong site.",
    platform_event: "Tumatakbo sa bawat event na maaaring matanggap ng iyong endpoints. Bahagi ito ng default na Developer webhooks workflow.",
    handoff_reminder_due: "Paalalahanan ang mga humahawak ng handoff na wala pang sumasagot.",
    handoff_escalation_due: "Sabihan ang Owners at Admins na masyado nang matagal na naghihintay ang handoff.",
    handoff_waiting_digest_due: "Ipadala ang buod sa umaga ng mga handoff na dumating sa labas ng office hours.",
    conversation_returned_to_queue: "Alertuhan ang team kapag umalis ang miyembro at bumalik sa queue ang mga usapan niya.",
    lead_followed_up: "Sabihan ang may-ari kapag nagtanong ulit ang bisita sa chat ng umiiral na lead.",
    gap_assigned: "Mag-follow up kapag may naitalagang knowledge gap na sasagutin.",
    connector_event_received: "Magsimula kapag sinabi ng konektadong system sa Sagot na may nangyari, gaya ng naipadalang order. Kailangan ng Pro plan.",
  },
  options: {
    attribute: "Attribute na babantayan",
    attributeChoose: "Pumili ng attribute",
    attributeGroups: { conversation: "Mga attribute ng usapan", visitor: "Mga attribute ng bisita", lead: "Mga attribute ng lead" },
    attributeGone: "{{label}} (wala na)",
    attributeHint:
      "Nagsisimula kapag nagbago ang attribute na ito: na-edit sa Inbox o sa lead, o ipinadala ng inyong site gamit ang Sagot('identify'). Ang pagbabagong gawa ng isang workflow ay hindi nagsisimula ng workflow, kaya walang paulit-ulit na loop. Ang parehong value na muling nakita sa loob ng 10 segundo ay isang beses lang magsisimula.",
    attributeFacts: "Magagamit sa mga kondisyon ang “Attribute”, “Dating value” at “Bagong value”. Sa mga mensahe at tala, magagamit ang mga variable na event.previous at event.value.",
    attributeNone: "Wala pang attribute. Gumawa muna ng isa, saka bumalik dito.",
    attributeNoneLink: "Gumawa ng attribute",
    attributeNoConversation: "Walang usapan sa likod ng attribute ng bisita o ng lead, kaya hindi magagamit ang mga step na para sa usapan (tags, status, tala, snooze …).",
    selector: "Elementong iki-click",
    selectorPlaceholder: "#apply-now, .tuition-cta",
    selectorHint: "Isang CSS selector para sa element sa inyong pahina. Hanggang 5, paghiwalayin ng kuwit. Pinapayagan: tags, #id, .class, [attribute=value], at espasyo o > sa pagitan ng mga ito.",
    selectorCount_one: "{{count}} selector ang naintindihan",
    selectorCount_other: "{{count}} selector ang naintindihan",
    selectorTest: "Subukan sa inyong pahina",
    selectorTestBody: "Buksan ang inyong pahina, buksan ang console ng browser at patakbuhin ang linya sa ibaba. Dapat nitong ilista ang element na ibig ninyo.",
    clickFrequency: "Gaano kadalas puwedeng magsimula",
    clickFrequencies: {
      every_click: "Bawat click (hanggang isang beses kada 30 segundo)",
      once: "Isang beses kada bisita",
      every_session: "Isang beses kada session ng pag-browse",
    },
    widgetOnly: "Sa website widget lang gumagana ang trigger na ito. Hindi nag-uulat ng click ang mga mobile app, Messenger at e-mail.",
    startTitle: "Bago ito gawin",
  },
  conditionFields: {
    event_changed_by: "Nagpalit",
    event_attribute: "Attribute",
    event_previous: "Dating value",
    event_value: "Bagong value",
    event_actor_user_id: "Miyembrong gumawa nito",
    event_changed: "Mga field na nagbago",
    source_notice: "Paano iuulat ang sync",
    source_run_kind: "Ano ang nagsimula ng sync",
    office_open: "Bukas ang opisina",    connector_event: "Pangalan ng event",
    connector_id: "Connector",
    connector_hook: "Hook",
  },
  conditionChoices: {
    choose: "Pumili",
event_changed_by: { staff: "Isang miyembro ng team", assistant: "Ang assistant", system: "Ang system (isang workflow o automation)", visitor: "Ang bisita (booking na ginawa niya)" },
    source_notice: { none: "Walang aabisuhan", in_app: "Sa app lang", email: "Sa e-mail lang", in_app_email: "Sa app at sa e-mail" },
    source_run_kind: { first: "Ang unang sync", manual: "Re-sync ng isang tao", scheduled: "Naka-iskedyul na re-crawl" },
  },
  problems: {
    needs_attribute: "Piliin kung aling attribute ang binabantayan ng workflow na ito.",
    needs_selector: "Piliin kung aling element sa pahina ang click na magsisimula ng workflow na ito.",
    selector_syntax: "Hindi wasto ang selector ng element. Gumamit ng tags, #id, .class at [attribute=value], halimbawa #apply-now, .tuition-cta.",
    selector_unsupported: "May ginamit ang selector ng element na hindi pinapayagan: mga pseudo-class tulad ng :has() o :nth-child, sibling combinator, * o attribute matcher tulad ng *=.",
    selector_too_many: "Hanggang 5 selector lang, paghiwalayin ng kuwit.",
    selector_too_long: "Hanggang 200 character lang ang selector ng element.",
    clicks_widget_only: "Sa website widget lang nagsisimula ang workflow dahil sa click. Alisin ang ibang channel.",
    bad_frequency: "Hindi akma sa trigger na ito ang dalas na {{frequency}}.",
  },
  attributeValues: {
    title: "Mga attribute",
    objects: { conversation: "Ang usapang ito", visitor: "Ang bisita", lead: "Ang lead na ito" },
    save: "I-save ang mga attribute",
    saved: "Na-save ang mga attribute.",
    notSet: "Wala pa",
    listPlaceholder: "Paghiwalayin ng kuwit",
    workflowHint: "Tumatakbo ang mga workflow na nagbabantay ng attribute kapag nagbago ito.",
    loadFailed: "Hindi namin ma-load ang mga attribute.",
  },
} as const;
